export const DIET_NUTRITION_FIELDS = [
  { key: "dietType", label: "Diet Type" },
  { key: "breakfast", label: "Breakfast" },
  { key: "lunch", label: "Lunch" },
  { key: "dinner", label: "Dinner" },
  { key: "snacksOrBeverages", label: "Snacks or Beverages" },
  { key: "waterPerDay", label: "Water Per Day" },
  { key: "foodInsensitivities", label: "Food Insensitivities" },
];
